<script lang="ts">
  import type { AppContext } from '../app';
  import { t } from '../i18n';
  import Icon from './icons/Icon.svelte';

  // The list view's key (S3-19). The dialog itself loads on first use (S4-03, D14: dialogs out of the start bundle).
  let { ctx }: { ctx: AppContext } = $props();
  let open = $state(false);

  export function show(): void {
    open = true;
  }
</script>

<button type="button" class="open" aria-label={$t('list.open')} title="{$t('list.open')} (L)" onclick={show}>
  <Icon name="list" />
</button>

{#if open}
  {#await import('./MissionListDialog.svelte') then { default: Dialog }}
    <Dialog {ctx} onclose={() => (open = false)} />
  {/await}
{/if}

<style>
  .open {
    min-width: var(--bar-h);
    display: grid;
    place-items: center;
    border-left: var(--rule-w) solid var(--rule);
    transition: color var(--dur-fast) var(--ease);
  }
  .open:hover {
    color: var(--accent);
  }
</style>
